import { put, call, takeEvery } from 'typed-redux-saga';
import BranchGateway from '~apis/branch';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetPendingBranchesListing(api: BranchGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingBranchesListingAttempt', handleGetPendingBranchesListing, api);
}

function* handleGetPendingBranchesListing(api: BranchGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            regionName,
        },
    } = reduxState.approval.pendingBranchesListing;
    const regions = reduxState.branch.allRegions;

    const regionId = regions.find(region => region.regionName === regionName)?.regionId;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingBranchesListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getBranchesChangeHistoryListing], {
        authToken,
        index,
        regionId: regionId || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingBranchesListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingBranchesListingSuccess(response.data));
    }
}
